import { render } from "./GenericChangeRequestForm.vue?vue&type=template&id=bdbdd586"
import script from "./GenericChangeRequestForm.vue?vue&type=script&lang=js"
export * from "./GenericChangeRequestForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__